export default __webpack_public_path__ + "static/favicon-160x160-a3c4ee2e440f0536ea65959902c5f1fb.png";